import React from "react";

const giftcardControllerRoute = [
  {
    key: "controller-giftcards",
    path: "/giftcard-controller/controller-giftcards",
    component: React.lazy(() => import("views/GiftcardController/giftCards")),
    authority: ["GiftcardController"],
  },
];

export default giftcardControllerRoute;
